module.exports = "https://la-static.vkplay.ru/promo/newstart/img/location-3.d2a5c54d.jpg";